import React from 'react';
import _ from 'lodash';

import { connectProps } from 'store';
import { langProp } from 'model/component-props';

import Draggable from "react-draggable";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Column, Table } from 'react-virtualized';

import CustomerCard from '../customercard/CustomerCard';
//import ListCustomer from '../listcustomer/ListCustomer';
import content from './content';
import spinner from '../../icons/spinner.svg';
import viewlist from '../../icons/view-list.png';
import gridview from '../../icons/grid-view.png';
import Searchbar from '../searchbar/Searchbar';
import './customersList.css';
import 'react-virtualized/styles.css';

import convert from 'xml-js';

import {
  updateCustomerSearchKey,
  updateCustomerSearchTerm,
  customerSearchKey,
  customerSearchTerm,
  userIDProp
} from 'model/component-props';

const TOTAL_WIDTH = 1100;

class Customers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewOption: 'cards',
            data: null,
            sortBy: 'No',
            sortDirection: 'ASC',
            widths: {
                No: 0.33,
                Name: 0.33,
                Outstanding_Orders: 0.45,
                Balance_LCY: 0.33,
                Address: 0.33,
                City: 0.33,
                Post_Code: 0.23,
                Phone_No: 0.43
            }
        }
    }

    componentDidMount(){
        let dataAsJson = {};
        let id = this.props.userIDProp;
        if (_.isEmpty(id)) {
          id = window.sessionStorage.getItem('userID');
        }
        if (_.isEmpty(id)) {
          return this.props.history.push('/login');
        }
        fetch(`${process.env.REACT_APP_NODE_SERVER}/getCustomers`, {
            crossDomain: true,
            method: 'POST',
            headers: {
                'Accept': 'text/xml',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({"id": id }),
        })
        .then(response => response.text())
        .then(str => {
            dataAsJson = convert.xml2json(str, { compact: true, spaces: 4 });
            return JSON.parse(dataAsJson);
        })
        .then(data => this.setState({ data }))
    }

    changeViewOption = (ev, option) => this.setState({viewOption: option});

    sort = ({sortBy, sortDirection}) => {
        //console.log({sortBy, sortDirection})
        this.setState({
          sortBy,
          sortDirection,
        })
    }

    render() {
        if(!this.state.data) {
            return (
                <div className="container-customersList">
                    <img src={spinner} alt="spinner" className="spinner" />
                </div>
            )
        }

        const {
          updateCustomerSearchKey,
          updateCustomerSearchTerm,
          customerSearchKey,
          customerSearchTerm,
          langProp
        } = this.props;
        const { data, widths } = this.state;
        const simplifiedData = data && _.get(data, ['Soap:Envelope', 'Soap:Body', 'ReadMultiple_Result', 'ReadMultiple_Result', 'CustBySalesperson']);
        const beautifiedData = _.map(simplifiedData, simple => _.reduce(simple, (r, value, key) => ({
          ...r,
          [key]: _.isString(value['_text']) ? value['_text'].trim() : value['_text']
        }), {}));
        const searchKeysList = ['Name', 'No', 'Address', "City", "Post_Code", "Phone_No", "Balance_LCY"];
        const filteredData = beautifiedData && beautifiedData.filter(obj =>
            _.has(obj, customerSearchKey) && _.includes(obj[customerSearchKey].toLowerCase(), customerSearchTerm.toLowerCase()));
            const tempList = _.sortBy([...filteredData], d => {
                return this.state.sortBy === 'Outstanding_Orders' || this.state.sortBy === 'Balance_LCY'
                ? parseFloat(d[this.state.sortBy])
                : d[this.state.sortBy];
              });
        const list = this.state.sortDirection === 'DESC' ? tempList.reverse() : tempList;
            return (
            <div>
                <div className="container">
                    <RadioGroup 
                        className={'radio'}
                        name={'view-option'}
                        value={this.state.viewOption}
                        onChange={this.changeViewOption}
                    >
                        <FormControlLabel value={'cards'} control={<Radio />} />
                        <img className="view" src={gridview}  alt="gridview"/>
                        <FormControlLabel value={'list'} control={<Radio />} />
                        <img className="view" src={viewlist}  alt="viewlist"/>
                    </RadioGroup>
                </div>
                {!_.isEmpty(beautifiedData) && <Searchbar
                  searchKeysList={searchKeysList}
                  updateSearchKey={key => updateCustomerSearchKey(key)}
                  updateSearchTerm={term => updateCustomerSearchTerm(term)}
                  searchKey={customerSearchKey || _.head(searchKeysList)}
                  searchTerm={customerSearchTerm}
                />}

                {this.state.viewOption === 'cards'
                    ? (
                        <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
                            {
                                filteredData.map((customer, i) => {
                                    return (  
                                        <CustomerCard
                                            key={i}
                                            Name={customer.Name}
                                            No={customer.No}
                                            Address={customer.Address}
                                            City={customer.City}
                                            Post_Code={customer.Post_Code}
                                            Phone_No={customer.Phone_No}
                                            Outstanding_Orders={customer.Outstanding_Orders}
                                            Balance_LCY={customer.Balance_LCY}
                                            Currency_Code={customer.Currency_Code}
                                        />
                                    )
                                })
                            }
                        </div>
                    )
                    : (  
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <Table className="customer-table"
                                style={{margin: '20px', overflowX: 'scroll'}}
                                rowStyle={{'border': '0.5px grey'}}
                                width={TOTAL_WIDTH}
                                height={500}
                                headerHeight={35}
                                headerStyle={{'color': 'white'}}
                                rowHeight={30}
                                rowCount={list.length}
                                rowGetter={({ index }) => list[index]}
                                sortBy={this.state.sortBy}
                                sortDirection={this.state.sortDirection}
                                sort={this.sort}
                            >

                                <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].No}
                                dataKey= 'No'
                                width={widths.No * TOTAL_WIDTH}
                                />

                                <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].Name}
                                dataKey='Name'
                                width={widths.Name * TOTAL_WIDTH}
                                />

                                <Column
                                headerRenderer={this.headerRenderer}
                                style={{textAlign: 'right'}}
                                label={content[langProp].Orders}
                                cellDataGetter={({ rowData }) => parseFloat(rowData.Outstanding_Orders).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                dataKey='Outstanding_Orders'
                                width={widths.Outstanding_Orders * TOTAL_WIDTH}
                                />

                                <Column
                                headerRenderer={this.headerRenderer}
                                style={{textAlign: 'right'}}
                                label={content[langProp].Balance_LCY}
                                cellDataGetter={({ rowData }) => parseFloat(rowData.Balance_LCY).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                dataKey='Balance_LCY'
                                width={widths.Balance_LCY * TOTAL_WIDTH}
                                />

                                <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].Address}
                                dataKey='Address'
                                width={widths.Address * TOTAL_WIDTH}
                                />

                                <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].City}
                                dataKey='City'
                                width={widths.City * TOTAL_WIDTH}
                                />

                                <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].Post_Code}
                                dataKey='Post_Code'
                                width={widths.Post_Code * TOTAL_WIDTH}
                                />

                                <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].Phone_No}
                                dataKey='Phone_No'
                                width={widths.Phone_No * TOTAL_WIDTH}
                                />
                            </Table>
                        </div>
                    )
                } 
            </div>
        );                                    
    }

    headerRenderer = ({
        columnData,
        dataKey,
        disableSort,
        label,
        sortBy,
        sortDirection
      }) => {
        return (
          <React.Fragment key={dataKey}>
            <div className="ReactVirtualized__Table__headerTruncatedText">
              {label}
            </div>
            <Draggable
              axis="x"
              defaultClassName="DragHandle"
              defaultClassNameDragging="DragHandleActive"
              onDrag={(event, { deltaX }) =>
                this.resizeRow({
                  dataKey,
                  deltaX
                })
              }
              position={{ x: 0 }}
              zIndex={999}
            >
              <span className="DragHandleIcon">|</span>
            </Draggable>
          </React.Fragment>
        );
      };
    
      resizeRow = ({ dataKey, deltaX }) =>
        this.setState(prevState => {
          const prevWidths = prevState.widths;
          const percentDelta = deltaX / TOTAL_WIDTH;
    
          //const nextDataKey = dataKey === "No" ? "Name" : "Outstanding_Orders";

          /*const nextDataKey = dataKey => {
              if(dataKey === 'No'){
                nextDataKey === 'Name';
              } else if(dataKey === 'Name') {
                nextDataKey === 'Outstanding_Orders';
              } else if(dataKey === 'Outstanding_Orders') {
                nextDataKey === 'Balance_LCY';
              } else if(dataKey === 'Balance_LCY') {
                nextDataKey === 'Address';
              } else if(dataKey === 'Address') {
                nextDataKey === 'City';
              } else if(dataKey === 'City') {
                nextDataKey === 'Post_Code';
              } else if(dataKey === 'Post_Code') {
                nextDataKey === 'Phone_No';
              }
            }*/

          return {
            widths: {
              ...prevWidths,
              [dataKey]: prevWidths[dataKey] + percentDelta,
              //[nextDataKey]: prevWidths[nextDataKey] - percentDelta
            }
          };
        });
}

export default connectProps(
  updateCustomerSearchKey,
  updateCustomerSearchTerm,
  customerSearchKey,
  customerSearchTerm,
  userIDProp,
  langProp
)(Customers);


// WEBPACK FOOTER //
// ./src/components/customerslist/CustomersList.js